import { integrations, showGoogleStatusModal, isLoading } from '../state'
// selectedIntegration kaldırıldı
import { integrationService } from '../../../services/integration/integration-service'
import { googleService } from '../../../services/google/google-service'
import { responseHandlerService } from '@/plugins/responseHandlerService'

/**
 * Toggles an integration's connected state
 * @param {number} id - ID of the integration to toggle
 * @param {Function} t - Translation function passed from parent
 * @param {Function} loadGoogleAccounts - Function to load Google accounts passed from parent
 */
export const toggleIntegration = async (id, t, loadGoogleAccounts) => {
  const integration = integrations.value.find((i) => i.id === id)
  if (!integration) return

  integration.loading = true

  try {
    if (!integration.connected) {
      // Special case for Google integration (ID=6)
      if (id === 6) {
        const isConnected = await googleService.checkGoogleConnection()

        if (!isConnected) {
          // Show Google modal and load accounts
          // selectedIntegration.value = integration - kaldırıldı
          showGoogleStatusModal.value = true
          
          // Load Google accounts data
          isLoading.value = true
          await loadGoogleAccounts()
          isLoading.value = false
        } else {
          // Already connected or direct connection
          await integrationService.connectIntegration(id)
        }
      } else {
        // Normal connection process for other integrations
        await integrationService.connectIntegration(id)
      }
    } else {
      // Disconnect process
      const result = await integrationService.disconnectIntegration(id, integrations.value)
      
      if (result.success) {
        responseHandlerService.handleSuccess(
          t('settings.components.integrations.responseHandler.success.disintegrationSuccessful', 
            { integrationName: result.name })
        )
      } else {
        responseHandlerService.handleError(
          null,
          t('settings.components.integrations.responseHandler.errors.integrationError',
            { integrationName: result.name })
        )
      }
    }
  } catch (error) {
    responseHandlerService.handleError(
      error,
      t('settings.components.integrations.responseHandler.errors.toggleIntegration')
    )
  } finally {
    setTimeout(() => {
      integration.loading = false
    }, 1000)
  }
}